import omit from 'lodash/omit';

import { EntityInput, EntityInputApiModel } from '@evidentid/tprm-portal-lib/models/dashboard';

import { convertEntityInputViewToData } from '@/modules/entity-management/utils/entityProcessing';

// The API takes exceptions as a list of `{ coverageType, until }`, while the entity form holds
// them as a map of requirement type to date. A map that is present, even an empty one, becomes a
// list; an entity with no exceptions at all is sent without the property, as it always was.
export function convertContractEntityToApiModel(entity: EntityInput): EntityInputApiModel {
    return entity.exceptions === undefined
        ? omit(entity, 'exceptions')
        : convertEntityInputViewToData(entity);
}
